import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// H0: riattivare un contatto disiscritto richiede Admin azienda + motivo, provenienza ed evidenza (tracciati)
export const ReactivationDialog = ({ contactId, onClose, onDone }) => {
  const [f, setF] = useState({ reason: "", source: "", evidence_ref: "" });
  const [busy, setBusy] = useState(false);
  const ok = Object.values(f).every((v) => v.trim().length >= 3);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/contacts/${contactId}/toggle-consent`, f);
      toast.success("Contatto riattivato con evidenza registrata");
      onDone?.(); onClose();
    } catch (e) {
      toast.error(formatApiErrorDetail ? formatApiErrorDetail(e) : (e?.response?.data?.detail?.message || "Riattivazione non consentita"));
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!contactId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="reactivation-dialog">
        <DialogHeader><DialogTitle>Riattiva contatto disiscritto</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Il contatto ha revocato il consenso. La riattivazione è riservata all'Admin azienda e viene registrata con operatore, data, motivo, provenienza ed evidenza del nuovo consenso.</p>
        {[["reason", "Motivo (es. nuovo modulo firmato in negozio)"], ["source", "Provenienza del consenso (es. modulo cartaceo, richiesta WhatsApp)"], ["evidence_ref", "Evidenza (numero modulo, ticket, data)"]].map(([k, l]) => (
          <div key={k} className="space-y-1"><label className="text-xs text-slate-600">{l}</label>
            <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`reactivation-${k}`} /></div>
        ))}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} data-testid="reactivation-cancel">Annulla</Button>
          <Button onClick={submit} disabled={!ok || busy} className="bg-[#10B981] hover:bg-[#059669]" data-testid="reactivation-confirm">Riattiva con evidenza</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
